import Exports from "./Exports";

export const translations = {
  en: {
    SearchforExports: "Search for Exports",
    CompanyName: "Company Name",
    BuyerID: "Buyer ID",
    ExportationID: "Exportation ID",
    SaleID: "Sale ID",
    Date: "Date",
    MineralType: "Mineral Type",
    Grade: "Grade",
    NetWeight: "Net Weight",
    Track: "Track",
    TimeTracking:"Time Tracking",
    QrCode: "Qr Code",
    Dashboard: "Dashboard",
    Exports: "Exports",
    TradeTimeline:"Trade Timeline",
    search: "Search for export",
    ExportationDetails: "Exportation Details",
    ExportationDate: "Exportation Date",
    GrossWeight: "Gross Weight",
    TransportDetails: "Transport Details",
    Destination: "Destination",
    Itinerary: "Itinerary",
    ShipmentNumber: "Shipment Number",
    Transporter: "Transporter",
    TruckFrontPlate: "Truck Front Plate",
    TruckBackPlate: "Truck Back Plate",
    RepresentativesDetails: "Representatives Details",
    RMBRepresentative: "RMB Representative",
    ExporterRepresentative: "Exporter Representative",
    TraceabilityAgent: "Traceability Agent",
    ShipmentDetails: "Shipment Details",
    Documents: "Documents",
    ProvisionalInvoice: "Provisional Invoice",
    FreightForwarderCargoReceipt: "Freight Forwarder's Cargo Receipt",
    ExporterSheet: "Exporter Sheet",
    AlexStewartCertificateOfAssay: "Alex Stewart Certificate of Assay",
    AlexStewartPackingReport: "Alex Stewart Packing report including weight",
    CertificateOfOrigin: "Certificate of Origin-certified by government authorities",
    ICGLRCertificate: "ICGLR Certificate",
    InlandTransportation: "Inland Transportation from Mine to the port",
    OriginalWarehouseCertificate: "Original Warehouse Certificate",
    CertificateOfInsurance: "Certificate of Insurance",
    BillOfLading: "Bill of Lading",
    C1Form: "C1 Form",
    C2Form: "C2 Form",
    MineSheets: "Mine Sheets",
    ProcessingSheets: "Processing Sheets",
    RRACustomsDeclaration: "RRA Customs Declaration",
    DGDACustomsDeclaration: "DGDA Customs Declaration",
    TagList: "Tag List",
    OtherScannedExporterDocuments: "Other Scanned Exporter Documents",
    OtherExporterDocuments: "Exporter Documents",
    OtherTransporterDocument: "Other Transporter Document",
    NoDocumentToDisplay: "There is no document to display",
    NumberOfTags: "Number of Tags",
    ShipmentTracking: "Shipment Tracking",
    TransportDetails: "Transport Details",
     NoExportRecords: "No export records to display yet"
  },
  fr: {
    SearchforExports: "Recherche de l'exportation",
    CompanyName: "Nom de l'entreprise",
    BuyerID: "ID de l'acheteur",
    SaleID: "ID de vente",
    ExportationID: "ID d'exportation",
    Date: "Date de l'exportation",
    MineralType: "Type de minéral",
    Grade: "Teneur",
    NetWeight: "Poids net (kg)",
    Track: "Trace",
    TradeTimeline:"Chronologie du commerce",
    TimeTracking:"Suivi du temps",
    QrCode: "Code Qr",
    Dashboard: "Tableau de bord",
    Exports: "Exportations",
    search: "Recherche de l'exportation",
    ExportationDetails: "Détails de l'exportation",
    ExportationDate: "Date de l'exportation",
    GrossWeight: "Poids brut",
    TransportDetails: "Détails du transport",
    Destination: "Destination",
    Itinerary: "Itinéraire",
    ShipmentNumber: "Numéro d'envoi",
    Transporter: "Transporteur",
    TruckFrontPlate: "Plaque avant du camion",
    TruckBackPlate: "Plaque arrière du camion",
    RepresentativesDetails: "Détails des représentants",
    RMBRepresentative: "Représentant RMB",
    ExporterRepresentative: "Représentant de l'exportateur",
    TraceabilityAgent: "Agent de traçabilité",
    ShipmentDetails: "Détails de l'envoi",
    Documents: "Documents",
    ProvisionalInvoice: "Facture provisoire",
    FreightForwarderCargoReceipt: "Récépissé de cargaison de l'expéditeur",
    ExporterSheet: "Fiche de l'exportateur",
    AlexStewartCertificateOfAssay: "Certificat d'analyse Alex Stewart",
    AlexStewartPackingReport: "Rapport d'emballage Alex Stewart, y compris le poids",
    CertificateOfOrigin: "Certificat d'origine certifié par les autorités gouvernementales",
    ICGLRCertificate: "Certificat ICGLR",
    InlandTransportation: "Transport intérieur de la mine au port",
    OriginalWarehouseCertificate: "Certificat d'entrepôt original",
    CertificateOfInsurance: "Certificat d'assurance",
    BillOfLading: "Connaissement",
    C1Form: "Formulaire C1",
    C2Form: "Formulaire C2",
    MineSheets: "Feuilles de la mine",
    ProcessingSheets: "Feuilles de traitement",
    RRACustomsDeclaration: "Déclaration douanière RRA",
    DGDACustomsDeclaration: "Bordereau en douane DGDA",
    TagList: "Liste des étiquettes",
    OtherScannedExporterDocuments: "Autres documents scannés de l'exportateur",
    OtherExporterDocuments: "documents de l'exportateur",
    OtherTransporterDocument: "Autres documents du transporteur",
    NoDocumentToDisplay: "Il n'y a pas de document à afficher",
    NumberOfTags: "Nombre d'étiquettes",
     ShipmentTracking: "Suivi de l'expédition",
    TransportDetails: "Détails du transport",
     NoExportRecords: "Aucun enregistrement d'exportation à afficher pour le moment"
  }
};
